// src/routes/ProtectedRoute.jsx
import { Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import Spinner from '../components/home/ui/Spinner';
import LayoutPrivado from '../layouts/LayoutPrivado';

// Hook simple de timeout para evitar spinners eternos
function useFailSafe(ms = 6000, active = true) {
  const [expired, setExpired] = useState(false);
  useEffect(() => {
    if (!active) return;
    const t = setTimeout(() => setExpired(true), ms);
    return () => clearTimeout(t);
  }, [ms, active]);
  return expired;
}

export default function ProtectedRoute({ children }) {
  const { currentUser, authLoading } = useAuth();
  const location = useLocation();
  const expired = useFailSafe(6000, authLoading);

  // Construimos redirect completo (ruta + query + hash)
  const redirectTarget = encodeURIComponent(
    `${location.pathname}${location.search || ''}${location.hash || ''}`
  );

  // Mientras carga, pero con límite
  if (authLoading && !expired) {
    return (
      <LayoutPrivado>
        <div className="flex justify-center items-center h-screen">
          <Spinner text="Verificando sesión..." />
        </div>
      </LayoutPrivado>
    );
  }

  // Si no hay usuario (o expiró la espera y seguimos sin user), redirigimos
  if (!currentUser) {
    return <Navigate to={`/auth?redirect=${redirectTarget}`} replace />;
  }

  // Usuario autenticado, render normal
  return children;
}
